import {
    TOOLTIP_CLASSNAME_TRIGGER_ELEMENT,
    createTooltip,
} from '@vfde-brix/ws10/tooltip';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { mountComponent } from '../util/mount';
import { HtmlId } from '../enums/elementId';
import { trackTooltipEvent } from '../tracking/tracking';

/**
 * Adds tracking event to the given tooltip
 *
 * @param tooltipId - ID of the tooltip
 */
export const addTooltipTrackingEvent = (tooltipId: string) => {
    const tooltipEl = document.getElementById(tooltipId);
    const [tooltipIcon] = tooltipEl?.parentElement?.getElementsByClassName(TOOLTIP_CLASSNAME_TRIGGER_ELEMENT) || [];

    tooltipIcon?.removeEventListener('mouseover', trackTooltipEvent);
    tooltipIcon?.addEventListener('mouseover', trackTooltipEvent, { once: true });
};

/**
 * Create Brix Tooltip component.
 *
 * @param id - Wrapper ID of the element.
 * @returns Tooltip component
 * or null if the element with the given ID is not found.
 */
export const mountTooltip = (id: HtmlId) => {
    const tooltip = mountComponent(id, createTooltip, NO_PATTERN_BUSINESS_LOGIC);

    tooltip && addTooltipTrackingEvent(id);

    return tooltip;
};
